import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { INTEGRATION_CONFIG_FIELD_SENSITIVE_VALUE_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_integration_config_field_sensitive_value_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';

export type SensitiveValueResponse = {
  value: any;
};

const useRetrieveConfigFieldSensitiveValue = (
  stepId: string,
  fieldId: string,
  enabled: boolean,
): UseQueryResult<SensitiveValueResponse, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: INTEGRATION_CONFIG_FIELD_SENSITIVE_VALUE_KEY(automationId, stepId, fieldId),
    queryFn: async () => {
      const response = await apiClient.get<SensitiveValueResponse>(
        get_integration_config_field_sensitive_value_url(automationId, stepId, fieldId),
      );
      return response.data;
    },
    enabled: !!automationId && enabled,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};

export default useRetrieveConfigFieldSensitiveValue;
